// extracted by mini-css-extract-plugin
export default {"input":"UniversalSearchForm_input__mKc0E","inputNotEmpty":"UniversalSearchForm_inputNotEmpty__3wbX0"};